import { cn } from "@/lib/cn";

import { Button } from "@/components/ui/button";

interface UserInfoProps {
  name: string;
  email: string;
  onLogout: () => void;
}

export const UserInfo = ({ name, email, onLogout }: UserInfoProps) => (
  <div
    className={cn("flex flex-col gap-2", "md:flex-row md:items-start md:justify-between md:gap-14")}
  >
    {/* Logout button - top on mobile, right side on desktop */}
    <Button
      variant="neutral"
      size="sm"
      onClick={onLogout}
      className="w-fit md:order-2"
    >
      Выйти
    </Button>

    <div className="flex flex-1 flex-col md:order-1 min-w-0">
      <h1 className="text-neutral-50 fs-700 font-bold truncate">{name}</h1>
      <p className="fs-500 md:fs-600 font-bold text-neutral-200/50 truncate">{email}</p>
    </div>
  </div>
);
